module.exports = __webpack_public_path__ + "static/media/greyLines.5ad4e3f9.svg";